<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('visitationPlan.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('visitationPlan.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <div class="row">
      <div class="col-md-3">
        <div class="form-group">
          <ts-card>
            <ts-card-wrapper>
              <ts-loading-banner :loading="loading">
                <form>
                  <fieldset>
                    <legend>{{ $t('visitationPlan.criteria') }}</legend>
                    <div class="row">
                      <div class="col-md-12 ts-space-y-1">
                        <label class="required ts-mb-0">{{
                          $t('visitationPlan.date')
                        }}</label>
                        <a-date-picker
                          v-model="model.date"
                          format="DD-MM-YYYY"
                          valueFormat="DD-MM-YYYY"
                          class="ts-w-full"
                        />
                      </div>
                    </div>
                    <div class="row ts-mt-3">
                      <div class="col-md-12 ts-space-y-1">
                        <label class="ts-mb-0">{{
                          $t('visitationPlan.saleName')
                        }}</label>
                        <a-select
                          v-model="model.employee_id"
                          mode='multiple'
                          :options="users"
                          showSearch
                          :filterOption="
                            (input, option) =>
                              option.componentOptions.children[0].text
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                          " 
                          class="ts-w-full"
                          :placeholder="$t('visitationPlan.saleName')"
                        ></a-select>
                      </div>
                    </div>
                    <div class="row ts-mt-3">
                      <div class="col-md-12 ts-space-y-1">
                        <label class="ts-mb-0">{{
                          $t('visitationPlan.reportType')
                        }}</label>
                        <a-radio-group
                          v-model="model.type" 
                          :default-value="1" class="ts-w-full">
                          <a-radio-button :value="1">
                            Commune
                          </a-radio-button>
                          <a-radio-button :value="2">
                            Customer
                          </a-radio-button>
                          <a-radio-button :value="3">
                            Monthly
                          </a-radio-button>
                        </a-radio-group>
                      </div>
                    </div>
                    <div class="row ts-mt-3">
                      <div class="col-md-6 text-right">
                        <ts-button
                          class="btn-block"
                          outline
                          color="success"
                          @click.prevent="exportExcel"
                          :waiting="exporting"
                          ><i class="fas fa-file-excel"></i>
                          {{ $t('excel') }}</ts-button
                        >
                      </div>
                      <div class="col-md-6 text-right">
                        <ts-button
                          class="btn-block"
                          color="primary"
                          @click.prevent="preview"
                          :waiting="waiting"
                          ><i class="fas fa-file-pdf text-red"></i>
                          {{ $t('preview') }}</ts-button
                        >
                      </div>
                    </div>
                  </fieldset>
                </form>
              </ts-loading-banner>
            </ts-card-wrapper>
          </ts-card>
        </div>
      </div>
      <div class="col-md-9">
        <ts-card>
          <ts-card-wrapper>
            <form>
              <fieldset>
                <legend>{{ $t('visitationPlan.preview') }}</legend>
                <ts-preview-pdf v-model="waiting" :src="src" />
              </fieldset>
            </form>
          </ts-card-wrapper>
        </ts-card>
      </div>
    </div>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import moment from 'moment'
import { mapActions } from 'vuex'
import * as FileDownload from 'downloadjs'
import { trim } from 'lodash'

export default {
  name: 'saleInvoiceReport',
  data() {
    return {
      waiting: false,
      loading: false,
      exporting: false,
      errors: new Errors(),
      src: '',
      users: [],
      model: {
        date: moment().format('DD-MM-YYYY'),
        type: 1,
        employee_id: []
      }
    }
  },
  methods: {
    ...mapActions('report/sale', [
      'visitation',
      'getUser'
    ]),
    fetchUser(){
      this.loading = true
      this.getUser()
        .then(response => {
            this.users = response.data.map(el => ({
              value: el.user_id,
              label: el.name
            }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => this.loading = false)
    },
    preview() {
      this.errors = new Errors()
      this.waiting = true
      this.src = ''
      this.visitation(this.model)
        .then((response) => {
          this.src = response.url
        })
        .catch((error) => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    exportExcel () {
      this.exporting = true
      this.errors = new Errors()
      this.$store
        .dispatch('report/sale/visitationExcel', this.model)
        .then(response => {
          let filename = trim(
            response.headers['content-disposition']
              .substring(
                response.headers['content-disposition'].indexOf('filename')
              )
              .replace('filename=', ''),
            '"'
          )
          FileDownload(response.data, filename)
        })
        .catch(err => {
          let error = JSON.parse(
            String.fromCharCode.apply(null, new Uint8Array(err))
          )
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => (this.exporting = false))
    },
  },
  beforeRouteEnter (to, from, next) {
    next(vm => vm.fetchUser())
  }
}
</script>
